import { NgModule } from '@angular/core';
import { Draggable } from './draggable.directive';
import { Droppable } from './droppable.directive';
import { DraggableHelper } from './draggableHelper.provider';
var DragAndDropModule = (function () {
    function DragAndDropModule() {
    }
    DragAndDropModule.forRoot = function () {
        return {
            ngModule: DragAndDropModule,
            providers: [
                DraggableHelper
            ]
        };
    };
    return DragAndDropModule;
}());
export { DragAndDropModule };
DragAndDropModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    Draggable,
                    Droppable
                ],
                exports: [
                    Draggable,
                    Droppable
                ]
            },] },
];
/** @nocollapse */
DragAndDropModule.ctorParameters = function () { return []; };
//# sourceMappingURL=dragAndDrop.module.js.map


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/angular-draggable-droppable/dist/esm/src/dragAndDrop.module.js
// module id = ../../../../angular-draggable-droppable/dist/esm/src/dragAndDrop.module.js
// module chunks = 42